export var extractNumbers = function (str, inputType) {
    return inputType === 'number'
        ? str
            .split('')
            .filter(function (char) { return /\d/.test(char); })
            .join('')
        : str;
};
export var splitStringByArray = function (str, lengths) {
    var startIndex = 0;
    var result = [];
    lengths.forEach(function (len) {
        var substring = str.substring(startIndex, startIndex + len);
        if (substring.endsWith('.') || substring.endsWith('/')) {
            substring = substring.slice(0, -1);
        }
        result.push(substring);
        startIndex += len;
    });
    return result;
};
/**
 * Splits a given string into an array of the specified length. If the string is shorter than the
 * specified length, the remaining spaces in the array are filled with the provided fill value.
 *
 * @param {string} string - The input string to be split.
 * @param {number} arrLength - The length of the output array.
 * @param {any} [fillValue=''] - The value to fill the remaining spaces in the array. Defaults to an empty string.
 * @returns {any[]} - The output array of the specified length.
 */
export var splitStringToLengthArray = function (string, arrLength, fillValue) {
    if (fillValue === void 0) { fillValue = ''; }
    var strArray = string.trim().split('').slice(0, arrLength);
    return strArray.concat(Array(arrLength).fill(fillValue)).slice(0, arrLength);
};
export var replaceArrayValueByIndex = function (arr, valueIndex, newValue) {
    var newArr = arr.map(function (value, index) {
        return index === valueIndex ? newValue : value;
    });
    return newArr;
};
/**
 * Generates a className string based on the given object map.
 *
 * @param classes - An object where the keys are class names and the values are booleans.
 * If the value is true, the class name (key) will be included in the resulting className string.
 * @returns A string with class names separated by spaces.
 */
export var classNames = function (classes) {
    return Object.entries(classes)
        .filter(function (_a) {
        var value = _a[1];
        return value;
    })
        .map(function (_a) {
        var key = _a[0];
        return key;
    })
        .join(' ');
};
//# sourceMappingURL=stringUtils.js.map